import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import apiServices from '../../services/service';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import {
  getAccountList,
  getActiveOwners,
  getContactList,
  getGenericMasterFilteredListByKey,
  getGridDataByModuleKey,
  getOpportunityList,
  getTagsByModule,
  getCampaignList,
  getUser,
} from '../../redux/selector';
import { fetchDataAndUpdateStore, fetchSelectedListAndAppendToModule } from '../../redux/actions';
import Loader from '../../shared/component/Loader';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import { dropdownPayload, opportunityInputData, ticketInputData } from '../../shared/constants';
import Select from 'react-select';
import schedule from '../../assets/img/leadsform/schedule.svg';
import Tags from '../sharedChild/tags';
import SelectBox from '../../shared/controls/form/selectBox';
import { validationSchemaDeal } from './validationSchema';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import FilterHandler from '../sharedChild/grid/filterHandler';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import ChildTicket from '../sharedChild/childTicket';
import ticket from '../../../src/assets/img/crm_home/header/ticket.png';
import useDealColumnDefs from './useDealColumnDefs';
import { updateGridColumnState } from '../../redux/reducer';
import { columnTypes } from '../../shared/initials';
import gridOptionsConfig from '../sharedChild/grid/gridOptionsConfig';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';

// const OptionButton = ({
//   handleClickOpenEditForm,
//   paramsValue,
//   handleOpenViewForm,
//   rowData,
//   handleClickDelete,
//   hasDeleteOpportunityPermission,
//   hasUpdateOpportunityPermission,
//   hasInfoOpportunityPermission,
// }) => {
//   const [showConfirmation, setShowConfirmation] = React.useState(false);

//   const handleDeleteClick = () => {
//     setShowConfirmation(true);
//   };

//   const handleConfirmDelete = () => {
//     handleClickDelete(paramsValue);
//     setShowConfirmation(false);
//   };

//   const handleCloseConfirmation = () => {
//     setShowConfirmation(false);
//   };

//   return (
//     <div className="action-menu">
//       {hasUpdateOpportunityPermission && (
//         <img
//           src="/assets/images/edit.png"
//           className="action-img1"
//           onClick={() => handleClickOpenEditForm(paramsValue)}
//           alt="Edit Opportunity"
//           title="Edit Opportunity"
//         ></img>
//       )}

//       {hasInfoOpportunityPermission && (
//         <img
//           src="/assets/images/view.png"
//           className="action-img2"
//           onClick={() => handleOpenViewForm(paramsValue)}
//           alt="View Opportunity"
//           title="View Opportunity"
//         ></img>
//       )}

//       {hasDeleteOpportunityPermission && (
//         <img
//           src="/assets/images/trash.png"
//           className="action-img2"
//           onClick={handleDeleteClick}
//           alt="Delete Opportunity"
//           title="Delete Opportunity"
//         ></img>
//       )}
//       <DeleteConfirmationModal
//         show={showConfirmation}
//         handleClose={handleCloseConfirmation}
//         handleConfirm={handleConfirmDelete}
//         rowData={rowData}
//       />
//     </div>
//   );
// };

// const DeleteConfirmationModal = ({
//   show,
//   handleClose,
//   handleConfirm,
//   rowData,
// }) => {
//   return (
//     <Modal show={show} onHide={handleClose} className="modal-delete">

//       {rowData && (
//         <>
//           <div className="warning-content">
//             <div className="warningOuter">
//               <div className="alertImg"><img src="../assets/images/delete-record.png" alt="Delete Record"></img></div>
//               <div className="warningText"> Are you sure you want to delete this opportunity
//                 <p>{rowData?.name}</p></div>
//             </div>
//             <div className="notes">
//               *Note: Any associated Activities, Visits, Drafts will also be Deleted.
//             </div>
//             <div className="warningBtn mt-2">
//               <Button variant="secondary" className='btn' onClick={handleClose}>
//                 Cancel
//               </Button>
//               <Button className='btn' variant="danger" onClick={handleConfirm}>
//                 Confirm Delete
//               </Button>
//             </div>

//           </div>
//         </>
//       )}

//     </Modal>
//   );
// };

function Deals() {
  const stateData = useSelector((state) => state);
  const contacts = useSelector(getContactList);
  const industryList = useSelector(getGenericMasterFilteredListByKey('Industry'));
  const leadSourceList = useSelector(getGenericMasterFilteredListByKey('LeadSource'));

  const stageDropdown = useSelector(getGenericMasterFilteredListByKey('Stage'));
  const projectTypeDropdown = useSelector(getGenericMasterFilteredListByKey('ProjectTypeCrm'));
  const accountNameDropdown = useSelector(getAccountList);
  const forecastCategoryDropdown = useSelector(
    getGenericMasterFilteredListByKey('ForecastCategory')
  );
  const campaignSourceDropdown = useSelector(getCampaignList);

  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(stateData, 'opportunityList');

  const reachOutForMarketingOptions = [
    { id: true, displayName: 'Yes' },
    { id: false, displayName: 'No' },
  ];
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const gridRef = useRef();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(storeLoading);
  const [updateListFlag, setUpdateListFlag] = useState(false);
  const navigate = useNavigate();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fieldValues, setFieldValues] = useState({});
  const [ownerFieldValues, setOwnerFieldValues] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSelectedOption, setIsSelectedOption] = useState(false);
  const [campaignData, setCampaignData] = useState([]);
  const [allcolumnList, setAllcolumnList] = useState([]);
  const [popupAction, setPopupAction] = useState('add');
  const [remindVisible, setRemindVisible] = useState(false);
  const [showReminderPage, setShowReminderPage] = useState(false);
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [filterJson, setfilterJson] = useState();
  const [gridParams, setGridParams] = useState(null);
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const gridOptions = gridOptionsConfig('opportunityList', navigate);

  useFetchIfNeeded(getOpportunityList, fetchDataAndUpdateStore, {
    key: 'opportunityList',
    inputData: opportunityInputData,
  });

  useFetchIfNeeded(getTagsByModule('opportunityList'), fetchDataAndUpdateStore, {
    key: 'tagsByModule',
    inputData: 'Opportunity',
    storeKey: 'opportunityList',
  });

  let hasUpdateOpportunityPermission = true;
  let hasCreateOpportunityPermission = true;
  let hasDeleteOpportunityPermission = true;
  let hasInfoOpportunityPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.opportunitymenu;

  if (userUIControlPermission) {
    hasCreateOpportunityPermission = userUIControlPermission?.opportunityaddscreen
      ? userUIControlPermission.opportunityaddscreen.canView
      : true;

    hasUpdateOpportunityPermission = userUIControlPermission?.opportunityupdatescreen
      ? userUIControlPermission.opportunityupdatescreen.canView
      : true;

    hasDeleteOpportunityPermission = userUIControlPermission?.opportunitydeletescreen
      ? userUIControlPermission.opportunitydeletescreen.canView
      : true;

    hasInfoOpportunityPermission = userUIControlPermission?.opportunityinfoscreen
      ? userUIControlPermission.opportunityinfoscreen.canView
      : true;
  }

  const rowData = useSelector(getOpportunityList);
  const gridData = useSelector(
    getGridDataByModuleKey('opportunityList', 'tags', 'stageDropdown', 'statusDropdown')
  );

  const ticketPriorityDropdown = useSelector(
    getGenericMasterFilteredListByKey('TicketPriorityCrm')
  );

  const ticketStatusDropdown = useSelector(getGenericMasterFilteredListByKey('StatusCrm'));

  const owner = useSelector(getActiveOwners);
  const userInfo = useSelector(getUser);
  const campaignListDropdown = useSelector(getCampaignList);

  const memberStatus = useSelector(getGenericMasterFilteredListByKey('CampaignMemberStatus'));

  const tagsList = useSelector(getTagsByModule('opportunityList'));

  const onSelectionChanged = (event) => {
    const gridApi = gridRef.current.api;
    const selectedRowsLocal = gridApi.getSelectedRows();
    const key = 'page-' + gridData?.inputPayload?.pageNumber;

    dispatch(
      fetchSelectedListAndAppendToModule({
        key: 'opportunityList',
        selectedList: { [key]: selectedRowsLocal },
      })
    );
  };

  const fullSelection = Object.values(gridDataSelection?.opportunityList || {}).flat();
  const emailPopup = () => {
    setIsOpen(!isOpen);
    if (isMinimized) setIsMinimized(false);
  };

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleGetMassPopup = () => {
    getAllColumns();
    setFieldValues({});
    setOwnerFieldValues((prevValues) => ({
      ...prevValues,
      ownerId: userInfo.user.userId,
    }));
    setIsSelectedOption(false);
    setSelectedOptions(null);
  };

  const handleSelection = (selectedOption) => {
    setIsSelectedOption(true);
    // Clear previous field value
    setFieldValues({});
    if (selectedOption.originalData.headerName === 'Industry') {
      selectedOption.originalData.data = industryList;
    } else if (selectedOption.originalData.headerName === 'Account Name') {
      selectedOption.originalData.data = accountNameDropdown;
    } else if (selectedOption.originalData.headerName === 'Lead Source') {
      selectedOption.originalData.data = leadSourceList;
    } else if (selectedOption.originalData.headerName === 'Contact Name') {
      selectedOption.originalData.data = contacts;
    } else if (selectedOption.originalData.headerName === 'Project Type') {
      selectedOption.originalData.data = projectTypeDropdown;
    } else if (selectedOption.originalData.headerName === 'Stage') {
      selectedOption.originalData.data = stageDropdown;
    } else if (selectedOption.originalData.headerName === 'Forecast Category') {
      selectedOption.originalData.data = forecastCategoryDropdown;
    } else if (selectedOption.originalData.headerName === 'Campaign Source') {
      selectedOption.originalData.data = campaignSourceDropdown;
    } else if (selectedOption.originalData.headerName === 'Reach Out For Marketing') {
      selectedOption.originalData.data = reachOutForMarketingOptions;
    } else if (selectedOption.originalData.headerName === 'Opportunity Owner') {
      selectedOption.originalData.data = owner;
    }
    setSelectedOption(selectedOption); // Update the selected value in state
    console.log('Selected Option:', selectedOption); // Log the selected value
  };

  const handleInputChange = (e, fieldName) => {
    const value = e.target.value;
    // For other fields, directly update the state
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };

  const handleDropdownChange = (selected, fieldName) => {
    const value = selected.value;
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));

    console.log(`Dropdown selected: ${value}`);
  };

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      // Format the selected data as required
      const formattedData = {
        fieldName: 'ownerId', // Static field name
        fieldValue: selectedOption.value, // The `value` from the dropdown
      };

      setOwnerFieldValues((prevValues) => ({
        ...prevValues,
        [formattedData.fieldName]: formattedData.fieldValue,
      }));
    }
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));
    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    if (name === 'memberStatusId') {
      setCampaignData({
        ...campaignData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    } else if (name === 'campaignId') {
      setCampaignData({
        ...campaignData,
        campaignId: selectedId,
      });
    } else if (name === 'statusId') {
      setFormData({
        ...formData,
        statusId: selectedId,
        status: selectedValue,
      });
    } else if (name === 'priorityId') {
      setFormData({
        ...formData,
        priorityId: selectedId,
        priority: selectedValue,
      });
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
    }
  };

  const handleMassUpdate = async (selectedRowData) => {
    setLoading(true); // Set loading state when starting mass update
    let result;
    console.log('selectedRowData', selectedRowData);

    // Extract the IDs from the selectedRowData array
    const ids = selectedRowData.map((item) => item.id);

    // Check if there is at least one field to update
    if (Object.keys(fieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(fieldValues)[0];

      // Validate the specific field using Yup's validateAt
      try {
        await validationSchemaDeal.validateAt(fieldName, {
          [fieldName]: fieldValue,
        });
      } catch (error) {
        if (error.name === 'ValidationError') {
          toast.error(`${error.message}`, { position: 'top-right' });
          setLoading(false); // Reset loading state on validation error
          return;
        }
      }

      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue.toString(),
      };
    } else {
      toast.error('No field values provided for update.', {
        position: 'top-right',
      });
      setLoading(false); // Reset loading state if no fields to update
      return;
    }

    console.log('result:', result);
    console.log('Submitted Values:', fieldValues);

    try {
      const response = await apiServices.updateMultipleOpportunityField(result);
      if (response.status === 200) {
        document.getElementById('massUpdateCancel').click();
        toast.success('Opportunity Updated Successfully!', {
          position: 'top-right',
        });
        handleGetMassPopup();
        dispatch(
          fetchDataAndUpdateStore({
            key: 'opportunityList',
            inputData: gridData?.inputPayload ? gridData?.inputPayload : opportunityInputData,
          })
        );
        dispatch(
          fetchDataAndUpdateStore({
            key: 'opportunityDropdown',
            inputData: dropdownPayload,
          })
        );
      } else {
        setLoading(false); // Reset loading state on error
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        // Loop through each error type (e.g., "EndDate") and display its messages
        Object.keys(errors).forEach((errorType) => {
          const errorMessages = errors[errorType];
          errorMessages.forEach((errorMessage) => {
            // Display each error message in the toaster
            toast.error(` ${errorMessage}`, {
              position: 'top-right',
            });
          });
        });
      }
      setLoading(false);
    }
  };

  const handleOwnerUpdate = (selectedRows) => {
    setLoading(true);
    let result;
    console.log('selectedRowData', selectedRows);
    // Extract the IDs from the selectedRowData array
    const ids = selectedRows.map((item) => item.id);
    if (Object.keys(ownerFieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(ownerFieldValues)[0];
      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue,
      };
    }
    apiServices
      .updateMultipleOpportunityField(result)
      .then((response) => {
        if (response.status === 200) {
          document.getElementById('ownerUpdateCancel').click();
          handleGetMassPopup();
          toast.success('Owner Updated Successfully!', {
            position: 'top-right',
          });
          setUpdateListFlag(true);
          dispatch(
            fetchDataAndUpdateStore({
              key: 'opportunityList',
              inputData: gridData?.inputPayload ? gridData?.inputPayload : opportunityInputData,
            })
          );
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleSubmit = (campaignData) => {
    // Implement campaign submit logic
  };

  // Add this method to get all columns
  const getAllColumns = () => {
    const columnApi = gridRef.current.columnApi;
    const data = columnApi.api.getAllGridColumns();
    const excludedColumns = [
      'Opportunity Name',
      'Account Name',
      'Contact Name',
      'Project Type',
      'Next Step',
      'Forecast Category',
      'Amount',
      'Stage',
      'Probability',
      'Closing Date',
      'Expected Revenue',
      'Campaign Source',
      'Reach Out For Marketing',
      'Description',
      'Technology Stack',
      'Opportunity Owner',
      'Industry',
      'Business Type',
      'Lead Source',
      'Source Name',
      'Other Source Name',
      'Line Of Business',
    ];
    const allColumns = data
      .map((col) => col.getColDef())
      .filter((colDef) => excludedColumns.includes(colDef.headerName));
    setAllcolumnList(allColumns);
  };

  // Add custom styles for Select component
  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid transparent' : '1px solid transparent',
      borderRadius: '5px',
      boxShadow: 'none',
      ':hover': {
        borderColor: 'transparent',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#888',
      fontSize: '.8rem',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: 'none',
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#E7F2FF',
      borderRadius: '50px',
      padding: '5px 14px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#707070',
      fontSize: '.8rem',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#4caf50',
      ':hover': {
        backgroundColor: '#d32f2f',
        color: '#fff',
      },
    }),
  };
  const handleClickDelete = (paramsValue) => {
    setLoading(true);

    // Creating the desired JSON object
    let data;
    // Creating the desired JSON object
    if (paramsValue.id === undefined) {
      const selectedIds = fullSelection.map((row) => row.id);
      data = { id: selectedIds };
    } else {
      data = {
        id: [paramsValue.id],
      };
    }
    apiServices
      .deleteOpportunity(data)
      .then((response) => {
        if (response.status === 200) {
          if (paramsValue.id === undefined) {
            document.getElementById('massDeleteModal').click();
          }
          setUpdateListFlag(true);
          setLoading(false);
          toast.success('Opportunity Deleted Successfully!', {
            position: 'top-right',
          });
          dispatch(
            fetchSelectedListAndAppendToModule({
              key: 'opportunityList',
              selectedList: {},
            })
          );
        } else {
          setLoading(false);
          toast.error('Error deleting record', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
        setLoading(false);
      });
  };
  const columnDefs = useDealColumnDefs({
    hasUpdateOpportunityPermission,
    hasInfoOpportunityPermission,
    hasDeleteOpportunityPermission,
    tagsList,
    leadSourceList,
    owner,
    gridData,
    open,
    stageDropdown,
    forecastCategoryDropdown,
    industryList,
    handleClickDelete,
    projectTypeDropdown,
  });

  // useEffect(() => {
  //   // setLoading(true)
  //   if (
  //     //campaignListDropdown.length > 0 &&

  //     tagsList.length > 0 &&
  //     stageDropdown.length > 0 &&
  //     forecastCategoryDropdown.length > 0 &&
  //     industryList.length > 0 &&
  //     // campaignSourceDropdown.length > 0 &&
  //     leadSourceList.length > 0 &&
  //     owner.length > 0
  //   ) {
  //     setColumnDefs([
  //       {
  //         headerName: "Actions",
  //         headerCheckboxSelection: true,
  //         checkboxSelection: true,
  //         cellRenderer: (params) => {
  //           const paramsValue = { ...params.data };
  //           return (
  //             <OptionButton
  //               hasDeleteOpportunityPermission={hasDeleteOpportunityPermission}
  //               hasInfoOpportunityPermission={hasInfoOpportunityPermission}
  //               hasUpdateOpportunityPermission={hasUpdateOpportunityPermission}
  //               rowData={paramsValue}
  //               openPopup={open}
  //               handleClickOpenEditForm={() =>
  //                 handleClickOpenEditForm(paramsValue)
  //               }
  //               handleClickDelete={() => handleClickDelete(paramsValue)}
  //               handleOpenViewForm={() => handleOpenViewForm(paramsValue)}
  //             />
  //           );
  //         },
  //         maxWidth: 100,
  //         minWidth: 100,
  //         sortable: false,
  //         filter: false,
  //         pinned: "left",

  //       },

  //       {
  //         headerName: "Opportunity Name",
  //         field: "name",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         cellRenderer: (params) => {
  //           if (!params.value) return null;
  //           return (
  //             <Link
  //               to={`/opportunity/viewOpportunity?${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
  //               state={params.data}
  //               style={{ fontWeight: "600" }}
  //             >
  //               {params.value}
  //             </Link>
  //           );
  //         },
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },

  //         pinned: isMobile() ? null : "left",
  //         minWidth: 180,
  //       },
  //       {
  //         headerName: "Account Name",
  //         field: "account",
  //         type: "dropdown",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },

  //         pinned: isMobile() ? null : "left",
  //         minWidth: 180,
  //       },
  //       {
  //         headerName: "Opportunity Owner",
  //         field: "owner",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             owner && owner.length > 0
  //               ? owner.map((item) => item.display_name)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //         // hide:true
  //       },
  //       {
  //         headerName: "Project Type",
  //         field: "projectType",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             projectTypeDropdown && projectTypeDropdown.length > 0
  //               ? projectTypeDropdown.map((item) => item.displayName)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },
  //       {
  //         headerName: "Contact Name",
  //         field: "contact",
  //         type: "dropdown",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Amount",
  //         field: "amount",
  //         type: "text",
  //         filter: "agNumberColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //         valueFormatter: currencyFormatterByField("amount"),
  //       },
  //       {
  //         headerName: "Stage",
  //         field: "stage",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             stageDropdown && stageDropdown.length > 0
  //               ? stageDropdown.map((item) => item.displayName)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },
  //       {
  //         headerName: "Probability",
  //         field: "probability",
  //         type: "text",
  //         filter: "agNumberColumnFilter",
  //         valueFormatter: (params) =>
  //           params.value != null ? `${params.value}%` : "",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Closing Date",
  //         field: "closingDate",
  //         type: "date",
  //         filter: "agDateColumnFilter",
  //         filterParams: filterParams,
  //         valueFormatter: DateFormatter,
  //       },
  //       {
  //         headerName: "Expected Revenue",
  //         field: "expectedRevenue",
  //         type: "text",
  //         filter: "agNumberColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //         valueFormatter: currencyFormatterByField("expectedRevenue"),
  //       },
  //       {
  //         headerName: "Campaign Source",
  //         field: "campaignSource",
  //         type: "dropdown",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           //   values: campaignSourceDropdown && campaignSourceDropdown.length > 0
  //           // ? campaignSourceDropdown.map(item => item.displayName)
  //           // : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Lead Source",
  //         field: "leadSource",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             leadSourceList && leadSourceList.length > 0
  //               ? leadSourceList.map((item) => item.displayName)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },
  //       {
  //         headerName: "Reach Out For Marketing",
  //         field: "reachOutForMarketing",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values: [true, false],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },
  //       {
  //         headerName: "Industry",
  //         field: "industry",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             industryList && industryList.length > 0
  //               ? industryList.map((item) => item.displayName)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },
  //       {
  //         headerName: "Business Type",
  //         field: "businessType",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Source Name",
  //         field: "sourceName",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Other Source Name",
  //         field: "otherSourceName",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //         hide: true,
  //       },
  //       {
  //         headerName: "Line Of Business",
  //         field: "lineOfBusiness",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Created By",
  //         field: "createdBy",
  //         valueFormatter: NameFormatter,
  //         minWidth: 230,
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Updated By",
  //         field: "updatedBy",
  //         valueFormatter: NameFormatter,
  //         minWidth: 230,
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Created Date Time(UTC)",
  //         field: "createdDateTime",
  //         valueFormatter: DateTimeFormatter,
  //         minWidth: 230,
  //         filter: "agDateColumnFilter",
  //         filterParams: filterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Updated Date Time(UTC)",
  //         field: "updatedDateTime",
  //         valueFormatter: DateTimeFormatter,
  //         minWidth: 230,
  //         filter: "agDateColumnFilter",
  //         filterParams: filterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Tags",
  //         field: "tagIds",
  //         valueGetter: (params) => params.data.tags,
  //         // filter: "agTextColumnFilter",
  //         // filterParams: {
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         // },
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             tagsList && tagsList.length > 0
  //               ? tagsList.map((item) => item?.name[0])
  //               : [],
  //           // columnKey: "tags",
  //           // fetchSelector: getTagsByModule,
  //           // fetchInput: { module: ["Contact"] },
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //         hide: true,
  //       },
  //       {
  //         headerName: "Next Step",
  //         field: "nextStep",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //         hide: true,
  //       },
  //       {
  //         headerName: "Forecast Category",
  //         field: "forecastCategory",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             forecastCategoryDropdown && forecastCategoryDropdown.length > 0
  //               ? forecastCategoryDropdown.map((item) => item.displayName)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //         hide: true,
  //       },
  //       {
  //         headerName: "Description",
  //         field: "description",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //         hide: true,
  //       },

  //       {
  //         headerName: "Technology Stack",
  //         field: "technologyStack",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //         hide: true,
  //       },

  //     ]);
  //   }
  //   // setLoading(false)
  // }, [
  //   loading,
  //   owner,
  //   tagsList,
  //   leadSourceList,
  //   forecastCategoryDropdown,
  //   industryList,
  // ]);
  const handleColumnChanged = (params) => {
    const columnApi = gridRef.current.columnApi;
    const columnState = columnApi.getColumnState();
    dispatch(
      updateGridColumnState({
        moduleKey: 'opportunityList',
        columnState: columnState,
      })
    );
  };
  const handleGridReady = (params) => {
    gridRef.current = params;
    setGridParams(params);
    const columnOrderFromStore = gridData?.columnState;

    if (columnOrderFromStore) {
      params.columnApi.applyColumnState({
        state: columnOrderFromStore,
        applyOrder: true,
      });
    } else {
      // apply default column visibility if no saved state
      const fieldsToHide = [
        'tagIds',
        'createdDateTime',
        'updatedDateTime',
        'otherSourceName',
        'nextStep',
        'forecastCategory',
        'description',
        'technologyStack',
      ];

      const defaultState = params.columnApi.getColumnState().map((col) => ({
        ...col,
        hide: fieldsToHide.includes(col.colId),
      }));

      params.columnApi.applyColumnState({
        state: defaultState,
        applyOrder: true,
      });
    }
  };

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalRowCountComponent', align: 'center' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  // const handleOpenAddForm = () => {
  //   const updatedObject = {
  //     ...initialValue,
  //     type: "add",
  //   };
  //   setDealsData(updatedObject);
  //   setOpen(true);
  // };

  // const handleClickOpenEditForm = (paramsValue) => {
  //   const updatedObject = {
  //     ...paramsValue,
  //     type: "edit",
  //   };
  //   setDealsData(updatedObject);
  //   setOpen(true);
  // };

  // const handleClickOpenEditForm = (paramsValue) => {
  //   navigate("/opportunity/editOpportunity", {
  //     state: paramsValue,
  //   });
  // };

  const handleOpenAddForm = () => {
    navigate('/opportunity/addOpportunity');
  };

  // const handleOpenViewForm =(paramsValue)=>{
  //   setViewOpen(true)
  // }

  // const handleOpenViewForm = (paramsValue) => {
  //   navigate(`/opportunity/viewOpportunity?id=${paramsValue.id}&pageNo=${gridData?.inputPayload?.pageNumber}`, {
  //     state: paramsValue,
  //   });
  // };

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
    getAllColumns();
  }, []);

  const cellClickedListener = useCallback((event) => {}, []);

  const handleAddTag = () => {
    setPopupAction('add');
    setShowPopup(true);
  };

  // When "Remove Tags" is clicked, set mode to "remove" and show the popup
  const handleRemoveTag = () => {
    setPopupAction('remove');
    setShowPopup(true);
  };
  const togglePopupVisibility = () => {
    setRemindVisible(!remindVisible);
    setShowReminderPage(false); // Reset to default page on close
  };

  const handleBackClick = () => {
    setShowReminderPage(false);

    setFormData((prev) => ({
      ...prev,
      showReminder: !!prev.reminder, // true if reminder exists, false otherwise
    }));
  };

  const handleDateTime = (e) => {
    const dataTime = e.target.value;
    setFormData({
      ...formData,
      reminder: dataTime,
    });
  };
  const handleReminderClick = () => {
    setShowReminderPage(!showReminderPage);
    // When turning off reminder, clear the reminder value
    if (showReminderPage) {
      setFormData({
        ...formData,
        reminder: '',
        showReminder: false,
      });
    } else {
      // When turning on, preserve existing reminder if any
      setFormData({
        ...formData,
        showReminder: true,
      });
    }
  };
  const handleOpportunityFormSubmit = (formData) => {
    setLoading(true);
    const ids = fullSelection.map((item) => item.id);
    const updatedFormData = {
      ...formData,
      opportunityId: ids.toString(),
    };
    apiServices
      .createTicketList(updatedFormData)
      .then((response) => {
        if (response.status === 200) {
          togglePopupVisibility();
          toast.success('Ticket created successfully!');
          dispatch(
            fetchDataAndUpdateStore({
              key: 'ticketList',
              inputData: ticketInputData,
            })
          );
          setFormData([]);
          setSelectedOptions(null);
          setLoading(false);
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };
  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
  };

  const filterDefaultSetRef = useRef(null);

  const handleFilterChanged = useCallback(
    (event) => {
      if (filterDefaultSetRef.current) {
        filterDefaultSetRef.current = false;
      } else {
        let filterModel = event.api.getFilterModel();
        console.log('Original Filter Model:', filterModel);

        // Create mappings for campaign names and tag names to their IDs
        const campaignMapping = {};
        if (campaignListDropdown?.length) {
          campaignListDropdown.forEach((item) => {
            campaignMapping[item.campaignName] = item.id;
          });
        }

        const tagMapping = {};
        if (tagsList?.length) {
          tagsList.forEach((item) => {
            tagMapping[item.name] = item.id;
          });
        }

        const updatedFilterModel = Object.keys(filterModel).reduce((acc, dynamicFilterKey) => {
          let filterData = filterModel[dynamicFilterKey];

          // Convert "set" filters to "text"
          console.log(`Updating ${dynamicFilterKey} from "set" to "text"`, filterData.values);

          if (dynamicFilterKey === 'campaignId') {
            // Convert campaign names to campaign IDs
            const idValues = filterData.values
              .map((name) => campaignMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          } else if (dynamicFilterKey === 'tagIds') {
            // Convert tag names to tag IDs
            const idValues = filterData.values
              .map((name) => tagMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          }

          // Keep Other Filters Unchanged
          else {
            acc[dynamicFilterKey] = filterData;
          }

          return acc;
        }, {});

        console.log('Updated Filter Model:', updatedFilterModel);

        const payload = {
          ...gridData?.inputPayload,
          filterJson: JSON.stringify(updatedFilterModel),
          pageNumber: 1, // Reset to first page on filter change
        };

        console.log('Filter Payload:', payload);

        dispatch(
          fetchDataAndUpdateStore({
            key: 'opportunityList',
            inputData: payload,
          })
        );
      }
    },
    [dispatch, gridData?.inputPayload, campaignListDropdown]
  );

  const handleSortChanged = useCallback(
    (event) => {
      const sortModel = event.columnApi
        .getAllDisplayedColumns()
        .map((col) => ({
          colId: col.getColId(),
          sort: col.getSort(),
        }))
        .filter((col) => col.sort);

      console.log('Sort Model:', sortModel);
      const columnName = sortModel.length > 0 ? sortModel[0].colId : 'UpdatedDateTime';
      const orderType = sortModel.length > 0 ? sortModel[0].sort : 'desc';

      const payload = {
        ...gridData?.inputPayload,
        columnName,
        orderType,
        pageNumber: 1, // Reset to first page on sort change
      };

      dispatch(
        fetchDataAndUpdateStore({
          key: 'opportunityList',
          inputData: payload,
        })
      );
    },
    [dispatch, gridData?.inputPayload]
  );

  const location = useLocation();

  const exportAll = async () => {
    setLoading(true);
    const fetchData = {
      ...opportunityInputData,
      pageSize: gridData?.totalCount,
      searchText: gridData?.inputPayload?.searchText ? gridData?.inputPayload?.searchText : null,
      filterJson: gridData?.inputPayload?.filterJson ? gridData?.inputPayload?.filterJson : null,
    };

    try {
      const response = await apiServices.exportAllOpportunity(fetchData);

      if (response?.data && response.status === 200) {
        setLoading(false);
        if (response?.data.includes('Export initiated.')) {
          toast.warning(response?.data); // Show toast
          setLoading(false);
        } else {
          // Convert data to Blob for better handling
          const blob = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = URL.createObjectURL(blob);

          // Create and trigger download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Opportunities.csv');
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // Free memory
        }
      } else {
        console.error('No data received from API.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error exporting Opportunities:', error);
      setLoading(false);
    }
  };

  const handleOpenManageTag = () => {
    navigate('/opportunity/manageTags', {
      state: { module: 'opportunityList', moduleApi: 'Opportunity' },
    });
  };

  // For Contact
  const {
    options: contactListDropdown,
    isLoading: isContactLoading,
    handleSearch: handleContactSearch,
    handleScroll: handleContactScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getContactsDropdown, // your API function
    responseKey: 'contactList', // expected response key
  });
  // Account dropdown
  const {
    options: accountListDropdown,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown, // Replace with actual API
    responseKey: 'accountList',
  });

  const {
    options: campaignList,
    isLoading: isCampaignLoading,
    handleSearch: handleCampaignSearch,
    handleScroll: handleCampaignScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getCampaignDropdown,
    responseKey: 'campaignList',
  });

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    // Check if userInfo exists and if the owner field hasn't been set yet.
    if (userInfo && userInfo?.user?.userId && !formData.owner) {
      // Update formData with the userInfo.userId.
      setFormData((prevData) => ({
        ...prevData,
        owner: userInfo?.user?.display_name,
        ownerId: userInfo?.user?.userId,
      }));
    }
  }, [remindVisible, userInfo, formData?.owner]);

  useEffect(() => {
    const gridApi = gridRef?.current?.api;
    if (gridApi && tagsList?.length > 0) {
      const tagFilterInstance = gridApi.getFilterInstance('tagIds');
      if (tagFilterInstance) {
        const newTagValues = tagsList.map((item) => item.name);
        tagFilterInstance.setFilterValues(newTagValues);
      }
    }
  }, [tagsList]);

  useEffect(() => {
    if (updateListFlag) {
      setUpdateListFlag(false);
      dispatch(
        fetchDataAndUpdateStore({
          key: 'opportunityList',
          inputData: opportunityInputData,
        })
      );
      dispatch(fetchDataAndUpdateStore({ key: 'opportunityDropdown' }));
    }
  }, [dispatch, updateListFlag]);

  useEffect(() => {
    if (!formData?.reminder) {
      setShowReminderPage(false);
      setFormData((prev) => ({
        ...prev,
        showReminder: false,
      }));
    }
  }, [formData?.reminder]);

  useEffect(() => {
    if (
      gridRef.current?.api &&
      gridData?.opportunity?.length &&
      //campaignListDropdown?.length ||
      tagsList?.length &&
      gridData?.inputPayload?.filterJson
    ) {
      try {
        // Parse filterJson
        const filterJson = JSON.parse(gridData.inputPayload.filterJson);

        // Extract tag IDs
        const tagIds = filterJson?.tagIds?.conditions
          ? filterJson.tagIds.conditions.map((condition) => condition.filter)
          : filterJson?.tagIds?.filter
            ? [filterJson.tagIds.filter]
            : [];
        setfilterJson(filterJson);

        //Create a mapping of tagId -> tagName
        const tagMapping = tagsList.reduce((acc, tag) => {
          acc[tag.id] = tag.name;
          return acc;
        }, {});

        // Get tag names from matched IDs (flattened)
        const matchedTagNames = tagIds.map((id) => tagMapping[id] || 'Unknown Tag').flat();

        // Update contacts with campaignName and tags
        const updatedCampaigns = gridData.opportunity.map((opportunity) => ({
          ...opportunity,
          tags: matchedTagNames, // Flattened array
        }));

        // Update grid data
        const updatedGridData = {
          ...gridData,
          opportunity: updatedCampaigns,
        };

        // Update the grid with new data
        gridRef.current.api.setGridOption('rowData', updatedGridData.opportunity);
        gridRef.current.api.refreshCells();
      } catch (error) {
        console.error('Error parsing filterJson:', error);
      }
    }
  }, [gridData]);

  // Restore selection on rowData change
  useEffect(() => {
    const gridApi = gridParams?.api;
    if (!gridApi || !gridData?.inputPayload?.pageNumber) return;

    const pageKey = 'page-' + gridData.inputPayload.pageNumber;
    const selectedRowsDefault = gridDataSelection?.opportunityList?.[pageKey] || [];

    if (selectedRowsDefault.length > 0) {
      gridApi.forEachNode((node) => {
        const isSelected = selectedRowsDefault.some((row) => row.id === node.data?.id);
        node.setSelected(isSelected);
      });
    } else {
      gridApi.deselectAll(); // Optional: clear selection
    }
  }, [gridParams, rowData, location.pathname]);

  return (
    <div className="inner-page" style={containerStyle}>
      <div className="dash-container">
        <div className="tbl_container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12">
              {fullSelection.length > 0 ? (
                <div className="main-hd">
                  <div className="left_lead">
                    <div className="heading_item topLink" id="createtask_dropdown">
                      <Link href="#" className="task_btn hd-btn" onClick={togglePopupVisibility}>
                        <img
                          src={ticket}
                          alt="Create Ticket"
                          className="me-2"
                          style={{ width: '14px', height: '14px' }}
                        />
                        <span className="btnText">Create Ticket</span>
                      </Link>
                    </div>
                    <div className="heading_item topLink" id="tags_dropdown">
                      <div className="dropdown">
                        <button
                          className=" btn action-btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Tags
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <li>
                            <Link className="dropdown-item" onClick={handleAddTag}>
                              Add Tags
                            </Link>
                          </li>
                          <li>
                            <Link className="dropdown-item" onClick={handleRemoveTag}>
                              Remove Tags
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="heading_item topLink" id="actiongrid_dropdown">
                      <div className="dropdown">
                        <button
                          className="btn action-btn dropdown-toggle "
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Actions
                        </button>

                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#myModal"
                            onClick={() => handleGetMassPopup()}
                          >
                            Mass Update
                          </li>
                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#myOwner"
                            onClick={() => handleGetMassPopup()}
                          >
                            Change Owner
                          </li>

                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#delete"
                          >
                            Delete
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="third-div">
                    <div className="heading_item ">
                      <div className="dsk">
                        <GlobalSearch
                          moduleName={'opportunityList'}
                          fullSelection={fullSelection}
                        />
                      </div>
                    </div>
                    <div className="heading_item text-bld">
                      <label>{/* 1 Record Selected: <span>Clear</span> */}</label>
                    </div>
                    <div className="heading_item text-bld">{/* <label>1-10</label> */}</div>
                    <div className="heading_item text-bld crsr">
                      {/* <Link>
                          <img src={arrowright} alt="arrow" />
                        </Link> */}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Opportunity
                  </div>

                  <div className="third-div mobView">
                    <div className="dsk">
                      <GlobalSearch moduleName={'opportunityList'} fullSelection={fullSelection} />
                    </div>

                    <div className="heading_item" id="actiongrid_dropdown">
                      <div className="dropdown">
                        <button
                          className="btn action-btn mobOption dropdown-toggle "
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="mob">
                            <i className="bi bi-three-dots"></i>
                          </div>{' '}
                          <div className="dsk">Options</div>
                        </button>

                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <li className="dropdown-item" onClick={handleOpenManageTag}>
                            Manage Tags
                          </li>
                          {/* <li className="dropdown-item">Deduplicate Leads</li> */}
                          <li
                            className="dropdown-item"
                            onClick={exportAll}
                            disabled={rowData && rowData.length === 0}
                          >
                            Export Opportunity
                          </li>
                        </ul>
                      </div>
                    </div>
                    {hasCreateOpportunityPermission && (
                      <div className="btn-group" id="timelogdropdown">
                        <button type="button" className="timelog-btn" onClick={handleOpenAddForm}>
                          {' '}
                          Create Opportunity
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="visually-hidden">Toggle Dropdown</span>
                        </button>
                        <ul className="dropdown-menu">
                          <Link className="dropdown-item" to="/opportunity/importOpportunity">
                            Import Opportunity
                          </Link>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="mob mb-3">
                <GlobalSearch moduleName={'opportunityList'} />
              </div>
              <div className="cutome_ag_theme">
                {loading && <Loader />}
                <div
                  className={`ag-theme-${selectedTheme} tbl_height`}
                  style={{ width: '100%', height: `100%` }}
                >
                  <AgGridReact
                    className="ag-grid-container" // Add a class for styling
                    domLayout="fixedHeight"
                    ref={gridRef} // Ref for accessing Grid's API
                    rowData={rowData} // Row Data for Row
                    columnDefs={columnDefs}
                    autoGroupColumnDef={autoGroupColumnDef}
                    defaultColDef={defaultColDef} // Default Column Properties
                    overlayLoadingTemplate={`<Loader />`}
                    animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                    rowSelection={'multiple'} // Options - allows click selection of rows
                    // statusBar={statusBar}
                    sideBar={sideBar} // pass side by making interface
                    enableRangeSelection={true}
                    suppressExcelExport={true}
                    suppressRowClickSelection={true}
                    groupSelectsChildren={true}
                    pivotPanelShow={'always'}
                    popupParent={popupParent}
                    sortingOrder={sortingOrder}
                    onFirstDataRendered={onFirstDataRendered}
                    onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                    rowDragManaged={true}
                    suppressMoveWhenRowDragging={true}
                    rowGroupPanelShow={'always'}
                    onSelectionChanged={onSelectionChanged}
                    onFilterChanged={handleFilterChanged}
                    gridOptions={gridOptions}
                    columnTypes={columnTypes}
                    onSortChanged={handleSortChanged}
                    onGridReady={handleGridReady}
                    onColumnMoved={handleColumnChanged}
                    onColumnVisible={handleColumnChanged}
                  />
                  {gridParams && (
                    <FilterHandler
                      params={gridParams}
                      gridData={gridData}
                      campaignListDropdown={campaignListDropdown}
                      tagsList={tagsList}
                      columnDefs={columnDefs}
                      filterDefaultSetRef={filterDefaultSetRef}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChildTicket
        remindVisible={remindVisible}
        showReminderPage={showReminderPage}
        handleBackClick={handleBackClick}
        togglePopupVisibility={togglePopupVisibility}
        formData={formData}
        handleDateTime={handleDateTime}
        handleChangeForm={handleChangeForm}
        errormsg={errormsg}
        handleChange={handleChange}
        selectedOptions={selectedOptions}
        ticketPriorityDropdown={ticketPriorityDropdown}
        owner={owner}
        ticketStatusDropdown={ticketStatusDropdown}
        handleReminderClick={handleReminderClick}
        loading={loading}
        handleFormSubmit={handleOpportunityFormSubmit}
      />{' '}
      {/* Popup Modal */}
      {showPopup && (
        <div id="genricPopup">
          <div className="popup-modal">
            <div className="popup-overlay">
              <div className="popup">
                <div className="popup-header">
                  <h2>{popupAction === 'add' ? 'Add Tags' : 'Remove Tags'}</h2>
                  <button
                    type="button"
                    className="custom-btn-close"
                    aria-label="Close"
                    onClick={togglePopup}
                  ></button>
                </div>

                {/* Pass a prop (like `removeMode`) to the Tags component
                  so that it can handle add vs. remove differently */}
                {popupAction === 'add' ? (
                  <Tags
                    module="Opportunity"
                    handleClose={togglePopup}
                    selectedRows={fullSelection}
                    storeKey={'opportunityList'}
                  />
                ) : (
                  <Tags
                    module="Opportunity"
                    removeMode={true}
                    handleClose={togglePopup}
                    selectedRows={fullSelection}
                    storeKey={'opportunityList'}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal structure Mass Update */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="myModal"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                <h5 className="modal-title" id="modalLabel">
                  Mass Update
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="input-container">
                      <label htmlFor="timeZoneId">Field</label>
                      <Select
                        value={isSelectedOption ? selectedOption : null}
                        options={allcolumnList?.map((data) => ({
                          value: data.field,
                          label: data.headerName,
                          originalData: data,
                        }))}
                        onChange={(selectedOption) => handleSelection(selectedOption)}
                        menuShouldScrollIntoView={false}
                        disabled={'timeZoneId'}
                        placeholder={'Select Field'}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? 'rgba(54, 83, 151, 0.3)'
                              : state.isFocused
                                ? '#365397'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#fff'
                              : state.isFocused
                                ? '#fff'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="input-container massInput">
                      {selectedOption && isSelectedOption ? (
                        selectedOption.originalData.type === 'text' ? (
                          <input
                            type="text"
                            placeholder={`Enter ${selectedOption.label}`}
                            value={fieldValues[selectedOption.value] || ''}
                            onChange={(e) => handleInputChange(e, selectedOption.value)}
                            style={{
                              width: '100%',
                              height: '40px',
                              borderRadius: '5px',
                              border: '1px solid #ccc', // Matches Select border color
                              padding: '8px 12px', // Matches Select padding
                              marginTop: '14px',
                              fontSize: '16px',
                              outline: 'none',
                              transition: 'border-color 0.3s, box-shadow 0.3s',
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#365397'; // Focus border color
                              e.target.style.boxShadow = '0 0 0 1px #365397'; // Focus box-shadow
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#ccc'; // Reset border color on blur
                              e.target.style.boxShadow = 'none'; // Remove box-shadow on blur
                            }}
                          />
                        ) : selectedOption.originalData.type === 'date' ? (
                          <input
                            type="date"
                            value={fieldValues[selectedOption.value] || ''}
                            onChange={(e) => handleInputChange(e, selectedOption.value)}
                            style={{
                              width: '100%',
                              height: '40px',
                              borderRadius: '5px',
                              border: '1px solid #ccc',
                              padding: '8px 12px',
                              marginTop: '14px',
                              fontSize: '16px',
                              outline: 'none',
                              transition: 'border-color 0.3s, box-shadow 0.3s',
                            }}
                          />
                        ) : selectedOption.originalData.type === 'dropdown' &&
                          selectedOption.originalData.headerName === 'Reach Out For Marketing' ? (
                          <Select
                            value={
                              // Check if the key exists in fieldValues (even if the value is false)
                              fieldValues.hasOwnProperty(`${selectedOption?.value}`)
                                ? (() => {
                                    const selectedValue = fieldValues[`${selectedOption?.value}`];
                                    // Use nullish coalescing to preserve false values
                                    const foundData = selectedOption.originalData.data?.find(
                                      (data) => (data.id ?? data.userId) === selectedValue
                                    );
                                    return {
                                      value: selectedValue,
                                      label:
                                        foundData?.displayName ||
                                        foundData?.display_name ||
                                        foundData?.name ||
                                        foundData?.fullName ||
                                        foundData?.campaignName ||
                                        '',
                                    };
                                  })()
                                : null
                            }
                            options={
                              selectedOption.originalData.data?.map((data) => ({
                                // Use nullish coalescing so that false is kept as a value
                                value: data.id ?? data.userId,
                                label:
                                  data.displayName ||
                                  data.display_name ||
                                  data.name ||
                                  data.fullName ||
                                  data.campaignName ||
                                  '',
                              })) || []
                            }
                            disabled
                            placeholder={`Select ${selectedOption.label}`}
                            menuPortalTarget={document.body} // Ensures the dropdown renders outside the modal
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderRadius: '5px',
                                marginTop: '14px',
                                borderColor: state.isFocused ? '#365397' : base.borderColor,
                                boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: '5px',
                                zIndex: 99999,
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 99999,
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isFocused ? '#365397' : base.backgroundColor,
                                color: state.isFocused ? '#fff' : base.color,
                                cursor: 'pointer',
                              }),
                              singleValue: (base) => ({
                                ...base,
                                padding: '2px 4px',
                                borderRadius: '3px',
                              }),
                            }}
                            onChange={(selected) =>
                              handleDropdownChange(selected, `${selectedOption.value}`)
                            }
                          />
                        ) : selectedOption.originalData.type === 'dropdown' ? (
                          selectedOption.originalData.headerName === 'Account Name' ? (
                            <SelectBox
                              name={'accountId'}
                              placeholder={'Select Account Name'}
                              selectedOptions={selectedOptions?.accountId}
                              handleSelect={handleDropdownChange}
                              options={accountListDropdown}
                              optionKeys={['id', 'name']}
                              errormsg={errormsg?.accountId}
                              isLoading={isAccountLoading}
                              onSearch={handleAccountSearch}
                              onScrollToBottom={handleAccountScroll}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  marginTop: '14px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? '#365397'
                                    : base.backgroundColor,
                                  color: state.isFocused ? '#fff' : base.color,
                                  cursor: 'pointer',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                }),
                              }}
                            />
                          ) : selectedOption.originalData.headerName === 'Contact Name' ? (
                            <SelectBox
                              name="contactId"
                              handleSelect={handleDropdownChange}
                              placeholder={'Select Contact'}
                              selectedOptions={selectedOptions?.contactId}
                              options={contactListDropdown}
                              isLoading={isContactLoading}
                              onScrollToBottom={handleContactScroll}
                              onSearch={handleContactSearch}
                              optionKeys={['id', 'name']}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  marginTop: '14px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? '#365397'
                                    : base.backgroundColor,
                                  color: state.isFocused ? '#fff' : base.color,
                                  cursor: 'pointer',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                }),
                              }}
                            />
                          ) : selectedOption.originalData.headerName === 'Campaign Source' ? (
                            <SelectBox
                              id="contactSelect"
                              name="campaignSourceId"
                              handleSelect={handleDropdownChange}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.campaignName || '--'
                                  : formData?.campaignName
                              }
                              selectedOptions={selectedOptions?.campaignId}
                              options={campaignList}
                              isLoading={isCampaignLoading}
                              onScrollToBottom={handleCampaignScroll}
                              onSearch={handleCampaignSearch}
                              optionKeys={['id', 'campaignName']}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  marginTop: '14px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? '#365397'
                                    : base.backgroundColor,
                                  color: state.isFocused ? '#fff' : base.color,
                                  cursor: 'pointer',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                }),
                              }}
                            />
                          ) : (
                            <Select
                              value={
                                // Check if the key exists in fieldValues (even if the value is false)
                                fieldValues.hasOwnProperty(`${selectedOption?.value}Id`)
                                  ? (() => {
                                      const selectedValue =
                                        fieldValues[`${selectedOption?.value}Id`];
                                      // Use nullish coalescing to preserve false values
                                      const foundData = selectedOption.originalData.data?.find(
                                        (data) => (data.id ?? data.userId) === selectedValue
                                      );
                                      return {
                                        value: selectedValue,
                                        label:
                                          foundData?.displayName ||
                                          foundData?.display_name ||
                                          foundData?.name ||
                                          foundData?.fullName ||
                                          foundData?.campaignName ||
                                          '',
                                      };
                                    })()
                                  : null
                              }
                              options={
                                selectedOption.originalData.data?.map((data) => ({
                                  // Use nullish coalescing so that false is kept as a value
                                  value: data.id ?? data.userId,
                                  label:
                                    data.displayName ||
                                    data.display_name ||
                                    data.name ||
                                    data.fullName ||
                                    data.campaignName ||
                                    '',
                                })) || []
                              }
                              disabled
                              placeholder={`Select ${selectedOption.label}`}
                              menuPortalTarget={document.body} // Ensures the dropdown renders outside the modal
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  marginTop: '14px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? '#365397'
                                    : base.backgroundColor,
                                  color: state.isFocused ? '#fff' : base.color,
                                  cursor: 'pointer',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                }),
                              }}
                              onChange={(selected) =>
                                handleDropdownChange(selected, `${selectedOption.value}Id`)
                              }
                            />
                          )
                        ) : selectedOption.originalData.type === 'number' ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              marginTop: '14px',
                              position: 'relative',
                            }}
                          >
                            {/* Input wrapper with relative position */}
                            {selectedOption.originalData.headerName === 'Annual Revenue' && (
                              <div
                                style={{
                                  position: 'relative',
                                  width: '100%',
                                }}
                              >
                                {/* Dollar symbol inside the input box */}
                                <span
                                  style={{
                                    position: 'absolute',
                                    left: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    fontSize: '16px',
                                    color: '#888',
                                    pointerEvents: 'none',
                                  }}
                                >
                                  $
                                </span>
                                <input
                                  type="number"
                                  placeholder={`Enter ${selectedOption.label}`}
                                  value={fieldValues[selectedOption.value] || ''}
                                  onChange={(e) => {
                                    // Enforce number limit conditionally for "Mobile"
                                    const value = e.target.value;
                                    if (
                                      selectedOption.originalData.headerName === 'Mobile' &&
                                      value.length > 15
                                    ) {
                                      return; // Prevent further input if length exceeds limit
                                    }
                                    handleInputChange(e, selectedOption.value); // Call your change handler
                                  }}
                                  style={{
                                    width: '100%',
                                    height: '40px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc',
                                    padding: '8px 12px 8px 30px', // Add padding-left to account for the dollar symbol
                                    fontSize: '16px',
                                    outline: 'none',
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#365397';
                                    e.target.style.boxShadow = '0 0 0 1px #365397';
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#ccc';
                                    e.target.style.boxShadow = 'none';
                                  }}
                                />
                              </div>
                            )}
                            {/* Input without the dollar sign for other cases */}
                            {selectedOption.originalData.headerName !== 'Annual Revenue' && (
                              <input
                                type="number"
                                placeholder={`Enter ${selectedOption.label}`}
                                value={fieldValues[selectedOption.value] || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (
                                    selectedOption.originalData.headerName === 'Mobile' &&
                                    value.length > 15
                                  ) {
                                    return;
                                  }
                                  handleInputChange(e, selectedOption.value);
                                }}
                                style={{
                                  width: '100%',
                                  height: '40px',
                                  borderRadius: '5px',
                                  border: '1px solid #ccc',
                                  padding: '8px 12px',
                                  fontSize: '16px',
                                  outline: 'none',
                                  transition: 'border-color 0.3s, box-shadow 0.3s',
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#365397';
                                  e.target.style.boxShadow = '0 0 0 1px #365397';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#ccc';
                                  e.target.style.boxShadow = 'none';
                                }}
                              />
                            )}
                          </div>
                        ) : (
                          <></>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancel_popup"
                  id="massUpdateCancel"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="save_popup"
                  onClick={() => handleMassUpdate(fullSelection)}
                  disabled={loading}
                >
                  Submit
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal structure Change Owner */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="myOwner"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                <h5 className="modal-title" id="modalLabel">
                  Change Owner
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-6" id="ownermodal">
                    <div className="input-container">
                      <label htmlFor="timeZoneId">Opportunity Owner</label>
                      <Select
                        value={
                          owner
                            ?.map((data) => ({
                              value: data.userId,
                              label: data.display_name,
                            }))
                            .find((option) => option.value === ownerFieldValues.ownerId) || null
                        }
                        options={owner?.map((data) => ({
                          value: data.userId,
                          label: data.display_name,
                        }))}
                        menuShouldScrollIntoView={false}
                        placeholder={userInfo?.user?.display_name}
                        onChange={handleSelectChange}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? 'rgba(54, 83, 151, 0.3)'
                              : state.isFocused
                                ? '#365397'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#fff'
                              : state.isFocused
                                ? '#fff'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                        menuPortalTarget={document.body}
                        components={{
                          DropdownIndicator: (props) => (
                            <div
                              {...props.innerProps}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16.3334 18.25V16.4167C16.3334 15.4442 15.9471 14.5116 15.2595 13.8239C14.5718 13.1363 13.6392 12.75 12.6667 12.75H5.33341C4.36095 12.75 3.42832 13.1363 2.74069 13.8239C2.05306 14.5116 1.66675 15.4442 1.66675 16.4167V18.25M12.6667 5.41667C12.6667 7.44171 11.0251 9.08333 9.00008 9.08333C6.97504 9.08333 5.33341 7.44171 5.33341 5.41667C5.33341 3.39162 6.97504 1.75 9.00008 1.75C11.0251 1.75 12.6667 3.39162 12.6667 5.41667Z"
                                  stroke="#9B9B9B"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-end">
                <button
                  type="button"
                  className="cancel_popup"
                  data-bs-dismiss="modal"
                  id="ownerUpdateCancel"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="save_popup "
                  onClick={() => handleOwnerUpdate(fullSelection)}
                  disabled={loading}
                >
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  Change Owner
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal structure Add To Campaigns */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="existing"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                <h5 className="modal-title" id="modalLabel">
                  Add to Campaigns
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeModalButton"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-12" id="myexisting">
                    <div className="input-container">
                      <label htmlFor="timeZoneId">Assign Campaign</label>
                      <Select
                        value={selectedOptions?.campaignId}
                        onChange={(selectedOption) => handleChange(selectedOption, 'campaignId')}
                        options={campaignListDropdown?.map((data) => ({
                          value: data.id,
                          label: data.campaignName,
                        }))}
                        menuShouldScrollIntoView={false}
                        placeholder={'Select Campaign'}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? 'rgba(54, 83, 151, 0.3)'
                              : state.isFocused
                                ? '#365397'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#fff'
                              : state.isFocused
                                ? '#fff'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                        menuPortalTarget={document.body}
                        components={{
                          DropdownIndicator: (props) => (
                            <div
                              {...props.innerProps}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <svg
                                width="20"
                                height="16"
                                viewBox="0 0 20 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0.694444 3.83398C0.310926 3.83398 0 4.12572 0 4.48556V9.5713C0 9.93114 0.310926 10.2229 0.694444 10.2229C1.07796 10.2229 1.38889 9.93114 1.38889 9.5713V4.48556C1.38889 4.12572 1.07796 3.83398 0.694444 3.83398Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M14.0917 0.222656H11.4687C11.1205 0.222656 10.8382 0.504721 10.8382 0.85264V1.42173L2.39558 3.92343C2.12793 4.00273 1.94434 4.2485 1.94434 4.52738V9.44226C1.94417 9.47375 1.9472 9.50551 1.95191 9.53734C1.95275 9.54322 1.95359 9.5491 1.9546 9.5549C1.95931 9.58094 1.96502 9.60698 1.97318 9.63285L3.7604 15.3363C3.84479 15.6057 4.09353 15.7782 4.36185 15.7782C4.42414 15.7782 4.48752 15.7689 4.55015 15.7493L7.15276 14.9361C7.31239 14.8862 7.44563 14.775 7.52313 14.627C7.60072 14.479 7.61619 14.3062 7.56626 14.1467L6.68059 11.3186L10.8382 12.5508V13.1198C10.8382 13.4678 11.1204 13.7498 11.4686 13.7498H14.0917C14.4398 13.7498 14.7221 13.4678 14.7221 13.1198V0.85264C14.7222 0.504721 14.4399 0.222656 14.0917 0.222656ZM6.17463 13.9216L4.77535 14.3588L3.53007 10.3848L5.22423 10.8869L6.17463 13.9216ZM5.90841 9.77556C5.90664 9.77506 5.90479 9.77447 5.90303 9.77396L3.20534 8.97439V4.99768L10.8383 2.73595V11.2367L5.90841 9.77556ZM13.4613 12.4899H12.0992V12.0806V1.89203V1.48271H13.4613V12.4899Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M19.0799 10.4739L16.2306 9.17481C15.9052 9.02664 15.5097 9.14663 15.347 9.44328C15.1843 9.73985 15.3162 10.1005 15.6415 10.2488L18.4908 11.5479C18.5854 11.591 18.6858 11.6113 18.7849 11.6113C19.0264 11.6113 19.259 11.4897 19.3744 11.2794C19.537 10.9828 19.4051 10.6222 19.0799 10.4739Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M15.9365 4.94575C16.0355 4.94575 16.136 4.92307 16.2305 4.87513L19.0798 3.43184C19.4051 3.26702 19.537 2.86642 19.3743 2.53688C19.2117 2.20735 18.8161 2.07375 18.4909 2.23857L15.6415 3.68186C15.3162 3.84667 15.1843 4.24727 15.347 4.57681C15.4624 4.81064 15.695 4.94575 15.9365 4.94575Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M19.3564 6.33398H17.032C16.6767 6.33398 16.3887 6.64491 16.3887 7.02843C16.3887 7.41195 16.6767 7.72287 17.032 7.72287H19.3564C19.7117 7.72287 19.9998 7.41195 19.9998 7.02843C19.9998 6.64482 19.7117 6.33398 19.3564 6.33398Z"
                                  fill="#9B9B9B"
                                />
                              </svg>
                            </div>
                          ),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-12">
                    <div className="input-container">
                      <>
                        <label htmlFor="timeZoneId">Select Member Status</label>
                        <Select
                          value={selectedOptions?.memberStatus}
                          placeholder={campaignData?.memberStatusId}
                          onChange={(selectedOption) =>
                            handleChange(selectedOption, 'memberStatusId')
                          }
                          options={memberStatus?.map((data) => ({
                            value: data.id,
                            label: data.displayName,
                          }))}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: '200px',
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: '9999',
                              height: '200px',
                              overflow: 'auto',
                              color: '#000',
                            }),
                            control: (base) => ({
                              ...base,
                              borderRadius: '50px',
                            }),
                          }}
                        />
                      </>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-end">
                <button type="button" className="cancel_popup" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="save_popup "
                  onClick={() => handleSubmit(campaignData)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal structure Delete */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="delete"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="warning-content">
                <div className="warningOuter">
                  <div className="alertImg">
                    <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
                  </div>
                  <div className="warningText">
                    {' '}
                    Are you sure you want to delete the selected record?
                  </div>
                </div>
                <div className="notes">
                  *Note: Any associated Activities, Visits, Drafts will also be Deleted.
                </div>
                <div className="warningBtn  mt-2">
                  <Button
                    variant="secondary"
                    className="btn"
                    data-bs-dismiss="modal"
                    id="massDeleteModal"
                  >
                    Cancel
                  </Button>
                  <Button className="btn" variant="danger" onClick={handleClickDelete}>
                    Confirm Delete
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal structure Email  */}
      <div className={`email-popup ${isOpen ? 'open' : ''} ${isMinimized ? 'minimized' : ''}`}>
        <div className="popup-header border_btm email_hd">
          <h5>New Message</h5>
          <div className="modal_btn_group">
            <button onClick={toggleMinimize} className="minimize-btn">
              <svg
                width="20"
                height="20"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="25"
                  height="25"
                  rx="5.5"
                  fill="white"
                  stroke="#9B9B9B"
                />
                <line x1="8" y1="18" x2="19" y2="18" stroke="#9B9B9B" strokeWidth="2" />
              </svg>
            </button>
            <button className="maxmin-btn">
              <svg
                width="20"
                height="20"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="25"
                  height="25"
                  rx="5.5"
                  fill="white"
                  stroke="#9B9B9B"
                />
                <path
                  d="M13.7222 12.2778L18 8M18 8H14.3333M18 8V11.6667M11.2778 14.7222L7 19M7 19H10.6667M7 19V15.3333"
                  stroke="#9B9B9B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <button onClick={emailPopup} className="close-btn">
              <svg
                width="20"
                height="20"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="25"
                  height="25"
                  rx="5.5"
                  fill="white"
                  stroke="#9B9B9B"
                />
                <path
                  d="M16.2989 17.6905L13.0093 14.3961L9.7198 17.6905C9.62799 17.7869 9.51786 17.8639 9.39589 17.917C9.27392 17.9702 9.14257 17.9984 9.00957 17.9999C8.87656 18.0015 8.74459 17.9764 8.6214 17.9262C8.49822 17.8759 8.38631 17.8015 8.29225 17.7073C8.1982 17.6131 8.1239 17.5011 8.07372 17.3777C8.02354 17.2543 7.9985 17.1222 8.00007 16.989C8.00164 16.8558 8.02978 16.7242 8.08284 16.6021C8.13591 16.4799 8.21283 16.3696 8.30907 16.2777L11.5986 12.9834L8.30907 9.68902C8.12921 9.50021 8.03024 9.24843 8.03331 8.9875C8.03638 8.72657 8.14125 8.4772 8.32549 8.29268C8.50974 8.10816 8.75875 8.00314 9.0193 8.00007C9.27985 7.997 9.53126 8.09611 9.7198 8.27623L13.0093 11.5706L16.2989 8.27623C16.4874 8.09611 16.7388 7.997 16.9994 8.00007C17.2599 8.00314 17.5089 8.10816 17.6932 8.29268C17.8774 8.4772 17.9823 8.72657 17.9854 8.9875C17.9884 9.24843 17.8895 9.50021 17.7096 9.68902L14.4201 12.9834L17.7096 16.2777C17.8956 16.4656 18 16.7195 18 16.9841C18 17.2487 17.8956 17.5026 17.7096 17.6905C17.6173 17.7839 17.5074 17.8581 17.3862 17.9086C17.265 17.9591 17.135 17.985 17.0037 17.9848C16.8725 17.9846 16.7426 17.9582 16.6216 17.9073C16.5006 17.8563 16.3909 17.7818 16.2989 17.688V17.6905Z"
                  fill="#9B9B9B"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="popup-body email_body">
          <div className="container_label border_btm">
            <div className="label_nm">
              <svg
                width="16"
                height="16"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.1668 20.125V18.2083C19.1668 17.1917 18.763 16.2166 18.0441 15.4978C17.3252 14.7789 16.3502 14.375 15.3335 14.375H7.66683C6.65017 14.375 5.67514 14.7789 4.95625 15.4978C4.23736 16.2166 3.8335 17.1917 3.8335 18.2083V20.125M15.3335 6.70833C15.3335 8.82542 13.6173 10.5417 11.5002 10.5417C9.38307 10.5417 7.66683 8.82542 7.66683 6.70833C7.66683 4.59124 9.38307 2.875 11.5002 2.875C13.6173 2.875 15.3335 4.59124 15.3335 6.70833Z"
                  stroke="#9B9B9B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div className="label_content">
                <label htmlFor="email">
                  <span
                    style={{
                      fontWeight: 'bold',
                      fontSize: '.8rem',
                    }}
                  >
                    John Doe
                  </span>{' '}
                  <span
                    style={{
                      color: '#666',
                      fontSize: '.8rem',
                    }}
                  >
                    &lt;johndoetest@nomail.com&gt;
                  </span>
                </label>
              </div>
            </div>
            <div className="heading_item" id="insert_template">
              <div className="dropdown">
                <button
                  className=" btn action-btn dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Insert Template
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <li>
                    <Link className="dropdown-item" href="#">
                      Add Template
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container_label border_btm">
            <div className="label_nm">
              <span> To :</span>

              <div className="label_content">
                <div>
                  <Select
                    isMulti
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    placeholder="Select options..."
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container_label border_btm">
            <div className="label_nm">
              <span>Subject :</span>

              <div className="label_content">
                <div>
                  <Select
                    isMulti
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    placeholder="Select options..."
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="email_group">
            <Link className="schedule-btn" type="button">
              <img src={schedule} alt="schedule" />
              Schedule
            </Link>
            <button className="add-btn" type="button">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deals;
